export default __webpack_public_path__ + "static/media/stoqueate_renewal-available_loan.d4d52ddf.jpg";